import { EventEmitter } from "events";

import Swagger from "swagger-client";
import { checkStatus, errorHandler, errorHandlerLogin } from "./helpers";
import axios from "axios";


class SessionStore extends EventEmitter {
  constructor() {
    super();
    this.client = null;
    this.user = null;
    this.organizations = [];
    this.settings = {};
    this.branding = {};

    this.swagger = Swagger("/swagger/internal.swagger.json", this.getClientOpts())

    this.swagger.then(client => {
      this.client = client;

      if (this.getToken() !== null) {
        this.fetchProfile(() => { });
      }
    });
  }

  getClientOpts() {
    return {
      requestInterceptor: (req) => {
        if (this.getToken() !== null) {
          req.headers["Grpc-Metadata-Authorization"] = "Bearer " + this.getToken();
        }
        return req;
      },
    }
  }

  setToken(token) {
    localStorage.setItem("jwt", token);
  }

  setToken2(token) {
    localStorage.setItem("jwt2", token);
  }

  getToken() {
    return localStorage.getItem("jwt");
  }

  getToken2() {
    return localStorage.getItem("jwt2");
  }

  getOrganizationID() {
    const orgID = localStorage.getItem("organizationID");
    if (orgID === "") {
      return null;
    }

    return orgID;
  }

  setOrganizationID(id) {
    localStorage.setItem("organizationID", id);
    this.emit("organization.change");
  }

  getUser() {
    return this.user;
  }

  getOrganization() {
    return this.organizations[0];
  }

  getSettings() {
    return this.settings;
  }

  isAdmin() {
    if (this.user === undefined || this.user === null) {
      return false;
    }
    return this.user.isAdmin;
  }

  isOrganizationAdmin(organizationID) {
    for (let i = 0; i < this.organizations.length; i++) {
      if (this.organizations[i].organizationID === organizationID) {
        return this.organizations[i].isAdmin;
      }
    }
  }

  login(login, callBackFunc) {
    this.swagger.then(client => {
      client.apis.InternalService.Login({ body: login })
        .then(checkStatus)
        .then(resp => {
          this.setToken(resp.obj.jwt);
          const self = this;
          axios.request({
            method: "post",
            url: 'https://authorization.ocupoly.com/api/v2/oauth2/token',
            auth: {
              username: "371qFEQNiQf8MAEyJQk0nTnG53VHbaK8",
              password: "D3AXSoo7GSBP5hUBYZcq1sMzKmw8W-mQ8FSvKqRjCn8WWHUgHOPLttWb3ntJbYX2"
            },
            data: "grant_type=client_credentials&audience=https://network.netemera.com/api/v4"
          }).then(function (response) {
            const accessToken = response.data.access_token;
            self.setToken2(accessToken);
            self.fetchProfile(callBackFunc);
            //window.setTimeout(function(){ self.logout(function() {}); }, 86400000);
          });
        })
        .catch(errorHandlerLogin);
    });
  }

  logout(callBackFunc) {
    localStorage.clear();
    this.user = null;
    this.organizations = [];
    this.settings = {};
    this.emit("change");
    callBackFunc();
  }

  fetchProfile(callBackFunc) {
    this.swagger.then(client => {
      client.apis.InternalService.Profile({})
        .then(checkStatus)
        .then(resp => {
          this.user = resp.obj.user;

          if (resp.obj.organizations !== undefined) {
            this.organizations = resp.obj.organizations;
            this.setOrganizationID(this.organizations[0].organizationID);
          }

          if (resp.obj.settings !== undefined) {
            this.settings = resp.obj.settings;
          }

          this.emit("change");
          callBackFunc();
        })
        .catch(errorHandler);
    });
  }

  globalSearch(search, limit, offset, callbackFunc) {
    this.swagger.then(client => {
      client.apis.InternalService.GlobalSearch({
        search: search,
        limit: limit,
        offset: offset,
      })
        .then(checkStatus)
        .then(resp => {
          callbackFunc(resp.obj);
        })
        .catch(errorHandler);
    });
  }

  getBranding(callbackFunc) {
    this.swagger.then(client => {
      client.apis.InternalService.Branding({})
        .then(checkStatus)
        .then(resp => {
          callbackFunc(resp.obj);
        })
        .catch(errorHandler);
    });
  }
}

const sessionStore = new SessionStore();
export default sessionStore;
